let count = 0;
let listeners = [];

const notify = () => listeners.forEach((fn) => fn(count > 0));

export const inc = () => { count++; notify(); };
export const dec = () => { count = Math.max(0, count - 1); notify(); };
export const subscribe = (fn) => {
  listeners.push(fn);
  return () => { listeners = listeners.filter((l) => l !== fn); };
};
